//import all svg files for carousel
const reqPngCarousel = require.context(
  "src/Common/Components/Carousel/Assets/Imgs",
  true,
  /\.png$/
);
const pngFileCarouselPaths = reqPngCarousel.keys();

//---Carousell---
export const carouselHeaderVn = " Người dùng nói gì về Ví ShopeePay?";
export const merchantCarouselHeaderVn =
  " Đối tác bán hàng nói gì về Ví ShopeePay?";

export const carouselDataVn = [
  {
    id: 0,
    image: reqPngCarousel(pngFileCarouselPaths[0]),
    name: "Ms. PT",
    age: "Người dùng ShopeePay",
    occupation: "Nhân viên văn phòng, Hà Nội",
    content:
      "“Thanh toán bằng Ví ShopeePay giúp tôi cảm thấy cuộc sống trở nên tiện nghi, hiện đại hơn. Là một người trẻ năng động, yêu thích những trải nghiệm mới mẻ nên với tôi phương thức thanh toán này khá sành điệu. Tôi nghĩ là thời gian tới mình sẽ ưu tiên sử dụng Ví ShopeePay nhiều hơn, không chỉ dành cho mua sắm mà còn đáp ứng các nhu cầu khác như giải trí, ăn uống.”",
  },
  {
    id: 1,
    image: reqPngCarousel(pngFileCarouselPaths[1]),
    name: "Ms. QN",
    age: "Người dùng ShopeePay",
    occupation: "Chuyên viên thu mua, Hồ Chí Minh",
    content:
      "“Là một tín đồ ẩm thực, hầu như ngày nào tôi cũng đặt đồ ăn qua ShopeeFood nên rất cần một phương thức thanh toán tiết kiệm như Ví ShopeePay. Chưa hết, nhờ ShopeePay, tôi không cần loay hoay tìm ví tiền khi shipper đến đột ngột, mà chỉ cần thảnh thơi di chuyển xuống dưới nhà nhận hàng”",
  },
  {
    id: 2,
    image: reqPngCarousel(pngFileCarouselPaths[2]),
    name: "Ms. DL",
    age: "Người dùng ShopeePay",
    occupation: "Giáo viên, Vũng Tàu",
    content:
      "“Tiết kiệm là ưu tiên hàng đầu của tôi khi mua sắm trực tuyến. Ngoài so sánh và lựa chọn giá thành phù hợp, khi áp dụng thêm mã giảm giá từ Ví ShopeePay, tôi còn mua được các món mình thích với giá rẻ hơn rất nhiều. Điều này không những mang lại niềm vui khi mua sắm, mà còn giúp tôi kiểm soát ngân sách chi tiêu hàng ngày tốt hơn”",
  },
  {
    id: 3,
    image: reqPngCarousel(pngFileCarouselPaths[3]),
    name: "Mr. MT",
    age: "Người dùng ShopeePay",
    occupation: "Kỹ sư, Hồ Chí Minh",
    content:
      "“Thanh toán hóa đơn qua Ví ShopeePay rất tiện lợi. Có nhiều điểm tôi thấy rất hay, hỗ trợ người dùng tốt, chẳng hạn chỉ cần nhập mã hóa đơn 1 lần thì thông tin sẽ được tự động lưu lại. Hàng tháng đến kỳ thanh toán thì có thông báo nhắc nhở. Tôi cũng coi được lịch sử giao dịch nên dễ dàng so sánh chi phí qua các tháng. Rất nhiều tiện ích mà không bị mất một khoản phí duy trì thường niên nào”",
  },
];

export const carouselDataVnEng = [
  {
    id: 0,
    image: reqPngCarousel(pngFileCarouselPaths[0]),
    name: "Ms. PT",
    age: "ShopeePay user",
    occupation: "Officer, Ha Noi",
    content:
      "“Payment via ShopeePay make I feel life is more convenient and modern. I’m a active characteristic and love to discover new experience therefore I evaluate Shopee is kinda trendy. I guess I will use more e-wallet, not only online shopping but also other service like entertainment, food & beverage services...”",
  },
  {
    id: 1,
    image: reqPngCarousel(pngFileCarouselPaths[1]),
    name: "Ms. QN",
    age: "ShopeePay user",
    occupation: "Purchasing, HCMC",
    content:
      "“Being a gourmet, I nearly book food via ShopeeFood everyday, so I really need an economic payment method as well as ShopeePay. Not finally, thank to ShopeePay, I don’t need to fumble about my wallet when shipper suddenly come, just need to take the delivery and done.”",
  },
  {
    id: 2,
    image: reqPngCarousel(pngFileCarouselPaths[2]),
    name: "Ms. DL",
    age: "ShopeePay user",
    occupation: "Teacher, Vung Tau",
    content:
      "“Economy is my priority when I’m shopping online. Besides compare and choose reasonable price, when I apply voucher from ShopeePay, I also can buy with much cheaper price. This not only bring about interest of shopping, but also help me to control daily budget much better.”",
  },
  {
    id: 3,
    image: reqPngCarousel(pngFileCarouselPaths[3]),
    name: "Mr. MT",
    age: "ShopeePay user",
    occupation: "Engineer, Ho Chi Minh City",
    content:
      "“Paying utility bills via ShopeePay is so convenient. Have a lot of nice points,  provide good care for customers, for example input bill code solely one time and information will be recorded. Customers can receive alerts of the monthly bill payment period. I can look back at my previous payment history to compare expenses monthly. There are so much convenience and don’t have any add on extra fee”",
  },
];

export const carouselDataMerchantVn = [
  {
    id: 0,
    image: reqPngCarousel(pngFileCarouselPaths[4]),
    name: "Mr. Heo Sung Jun",
    age: "Giám đốc Vận hành",
    occupation: "GS25 Việt Nam",
    content:
      "“Ví ShopeePay giúp nhân viên GS25 xử lý giao dịch nhanh chóng hơn, tăng năng suất phục vụ khách hàng đặc biệt là trong những khung giờ cao điểm. Cửa hàng cũng đang có thêm lượt khách hàng nhờ tiếp cận được rộng rãi đến tập khách hàng của Shopee.”",
  },
  {
    id: 1,
    image: reqPngCarousel(pngFileCarouselPaths[5]),
    name: "Mr. Tran Van Truong",
    age: "Tổng giám đốc",
    occupation: "Homefarm",
    content:
      "“Đối với Homefarm, nhân viên sẽ dễ dàng kiểm soát đơn hàng của khách hàng khi thanh toán qua Ví ShopeePay. Thanh toán diễn ra nhanh chóng chỉ qua một bước quét mã, tối ưu không chỉ về khâu thanh toán mà còn rút gọn các bước, nâng cao trải nghiệm cho khách hàng và cho cửa hàng.”",
  },
  {
    id: 2,
    image: reqPngCarousel(pngFileCarouselPaths[6]),
    name: "Ms. Vi Phuong Hoai",
    age: "Trà Sữa Mixue",
    occupation: "",
    content:
      "“Thanh toán qua Ví ShopeePay giúp cửa hàng dễ dàng quản lý doanh thu và thu hút được nhiều khách hàng mới hơn nhờ các chương trình khuyến mãi, voucher giảm giá khi thanh toán qua Ví ShopeePay”",
  },
  {
    id: 3,
    image: reqPngCarousel(pngFileCarouselPaths[7]),
    name: "Ms. Vy Nguyen",
    age: "Đen Đá Cafe",
    occupation: "",
    content:
      "“Thanh toán qua ShopeePay giúp khách hàng và nhân viên hạn chế sử dụng tiền mặt trong thời điểm giãn cách. Đối với Đen Đá Cafe, các thao tác kiểm tra doanh thu điện tử cũng rất nhanh chóng và dễ dàng. Khách hàng phần lớn thích thanh toán qua ShopeePay do có nhiều mã hoàn xu, và có thể nạp/rút tiền dễ dàng, đặc biệt có thể chia tiền trong bill sau khi thanh toán”",
  },
  {
    id: 4,
    image: reqPngCarousel(pngFileCarouselPaths[8]),
    name: "Ms. Thuy Pham",
    age: "Quản lý bộ phận Marketing ",
    occupation: "MEDiCARE",
    content:
      "“Ví ShopeePay giúp quá trình thanh toán tại cửa hàng trở nên tiện lợi và nhanh chóng hơn, mang lại cho khách hàng nhiều sự lựa chọn và nhiều ưu đãi. Tạo điều kiện cho cửa hàng MEDiCARE trở thành điểm mua sắm quen thuộc với nhóm khách hàng sử dụng ví ShopeePay”",
  },
];
